<template>
  <div>
    <v-btn v-for="action in actions"
           :key="action.name"
           :class="actions.length > 1 ? 'mr-2' : ''"
           :icon="'icon' in action"
           :title="'icon' in action ? action.name : ''"
           @click="action.click(item)">
      <v-icon v-if="'icon' in action">{{ action.icon }}</v-icon>
      <span v-if="!'icon' in action && 'iconOnly' in action && action.iconOnly">{{ action.name }}</span>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "ActionsButtonsCell",
  props: {
    item: {},
    header: {}
  },
  computed: {
    componentProps() {
      return this.header.componentProps
    },
    actions() {
      return this.componentProps.actions
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>
